import styled from "styled-components";

const TableLayoutFooter = styled.div`
  display: flex;
  flex: 1;
`;

export default TableLayoutFooter;
